/**
 * 프로젝트별 API 엔드포인트 레지스트리
 * 각 서브도메인의 API 엔드포인트 메타데이터 정의
 */

export const PROJECT_API_REGISTRY = {
  main: {
    name: 'Main',
    category: '플랫폼',
    baseUrl: '/api',
    endpoints: [
      { method: 'POST', path: '/api/login', name: '로그인', description: '이메일/비밀번호 로그인' },
      { method: 'POST', path: '/api/signup', name: '회원가입', description: '신규 계정 등록' },
      { method: 'POST', path: '/api/social-login', name: '소셜 로그인', description: 'Google/Kakao 소셜 로그인' },
      { method: 'GET', path: '/api/auth/me', name: '내 정보', description: '현재 사용자 정보 조회' },
      { method: 'GET', path: '/api/users', name: '사용자 목록', description: '전체 사용자 목록 (Admin)' },
      { method: 'PUT', path: '/api/users/:id/tier', name: '등급 변경', description: '사용자 등급 변경 (Admin)' },
      { method: 'GET', path: '/api/news/briefing', name: '뉴스 브리핑', description: 'AI 뉴스 브리핑 조회' },
      { method: 'GET', path: '/api/admin/stats', name: '관리자 통계', description: '대시보드 통계 (Admin)' },
    ]
  },

  auth: {
    name: 'Auth',
    category: '인증',
    baseUrl: '/api',
    endpoints: [
      { method: 'POST', path: '/api/login', name: '로그인', description: '이메일/비밀번호 로그인' },
      { method: 'POST', path: '/api/signup', name: '회원가입', description: '신규 계정 등록' },
      { method: 'GET', path: '/api/auth/google', name: 'Google OAuth', description: 'Google 로그인 시작' },
      { method: 'GET', path: '/api/auth/kakao', name: 'Kakao OAuth', description: 'Kakao 로그인 시작' },
      { method: 'GET', path: '/api/auth/config', name: 'OAuth 설정', description: 'OAuth 공개 설정 조회' },
      { method: 'GET', path: '/api/me', name: '내 정보', description: '현재 사용자 정보' },
      { method: 'GET', path: '/api/verify', name: '토큰 검증', description: 'JWT 토큰 유효성 확인' },
      { method: 'GET', path: '/api/level/info', name: '레벨 정보', description: '사용자 레벨/경험치' },
      { method: 'POST', path: '/api/level/checkin', name: '출석 체크', description: '일일 출석 체크' },
      { method: 'GET', path: '/api/rankings/level', name: '레벨 랭킹', description: '레벨 순위표' },
    ]
  },

  community: {
    name: 'Community',
    category: '커뮤니티',
    baseUrl: '/api/community',
    endpoints: [
      { method: 'GET', path: '/api/community/posts', name: '게시글 목록', description: '게시글 조회 (카테고리별)' },
      { method: 'POST', path: '/api/community/posts', name: '게시글 작성', description: '새 게시글 작성' },
      { method: 'GET', path: '/api/community/posts/:id', name: '게시글 상세', description: '게시글 상세 조회' },
      { method: 'PUT', path: '/api/community/posts/:id', name: '게시글 수정', description: '게시글 수정' },
      { method: 'DELETE', path: '/api/community/posts/:id', name: '게시글 삭제', description: '게시글 삭제' },
      { method: 'POST', path: '/api/community/posts/:id/comments', name: '댓글 작성', description: '댓글 달기' },
      { method: 'DELETE', path: '/api/community/comments/:id', name: '댓글 삭제', description: '댓글 삭제' },
      { method: 'GET', path: '/api/news/briefing', name: '뉴스 브리핑', description: 'AI 뉴스 브리핑' },
      { method: 'GET', path: '/api/youtube/trends', name: 'YouTube 트렌드', description: 'AI 기반 트렌드 분석' },
    ]
  },

  stock: {
    name: 'Stock',
    category: '주식',
    baseUrl: '/api/stock',
    endpoints: [
      { method: 'GET', path: '/api/stock/search', name: '종목 검색', description: '키워드로 종목 검색' },
      { method: 'GET', path: '/api/stock/:symbol', name: '종목 상세', description: '특정 종목 현재가 정보' },
      { method: 'GET', path: '/api/stock/:symbol/chart', name: '차트 데이터', description: '주가 차트 데이터 (일봉/주봉/월봉)' },
      { method: 'GET', path: '/api/stock/favorites', name: '관심종목 조회', description: '사용자 관심종목 목록' },
      { method: 'POST', path: '/api/stock/favorites', name: '관심종목 추가', description: '관심종목에 추가' },
      { method: 'DELETE', path: '/api/stock/favorites/:symbol', name: '관심종목 삭제', description: '관심종목에서 제거' },
      { method: 'GET', path: '/api/stock/market/indices', name: '시장 지수', description: '코스피/코스닥 지수' },
      { method: 'GET', path: '/api/stock/market/top', name: '상위 종목', description: '거래량/상승률 상위 종목' },
    ]
  },

  ai: {
    name: 'AI',
    category: 'AI',
    baseUrl: '/api/ai',
    endpoints: [
      { method: 'POST', path: '/api/ai/chat', name: 'AI 채팅', description: 'AI 대화 (Groq/Gemini)' },
      { method: 'POST', path: '/api/ai/summarize', name: '콘텐츠 요약', description: '긴 텍스트를 AI로 요약' },
      { method: 'POST', path: '/api/ai/transform', name: '콘텐츠 변환', description: '문체/형식 변환' },
      { method: 'POST', path: '/api/ai/upscale', name: '이미지 업스케일', description: '이미지 해상도 향상' },
      { method: 'POST', path: '/api/ai/image-to-video', name: '이미지→영상', description: 'Kling AI 영상 생성' },
      { method: 'GET', path: '/api/ai/job/:jobId', name: '작업 상태', description: 'AI 작업 진행 상태 조회' },
      { method: 'GET', path: '/api/ai/usage', name: '사용량 조회', description: 'AI 사용량 통계 (Admin)' },
      { method: 'POST', path: '/api/audio/transcribe', name: '음성→텍스트', description: 'Whisper 음성 인식' },
      { method: 'POST', path: '/api/audio/analyze', name: '오디오 분석', description: '오디오 콘텐츠 분석' },
    ]
  },

  family: {
    name: 'Family',
    category: '캘린더',
    baseUrl: '/api/calendar',
    endpoints: [
      { method: 'GET', path: '/api/calendar/events', name: '일정 목록', description: 'Google Calendar 일정 조회' },
      { method: 'POST', path: '/api/calendar/events', name: '일정 생성', description: '새 일정 추가' },
      { method: 'PUT', path: '/api/calendar/events/:id', name: '일정 수정', description: '일정 수정' },
      { method: 'DELETE', path: '/api/calendar/events/:id', name: '일정 삭제', description: '일정 삭제' },
      { method: 'GET', path: '/api/calendar/auth/url', name: 'Google 인증 URL', description: 'OAuth 인증 URL' },
      { method: 'POST', path: '/api/calendar/auth/callback', name: 'Google 인증 콜백', description: 'OAuth 콜백 처리' },
    ]
  },

  lab: {
    name: 'Lab',
    category: '파일/게임',
    baseUrl: '/api/files',
    endpoints: [
      { method: 'POST', path: '/api/files/upload', name: '파일 업로드', description: '파일 업로드 (이미지/비디오/문서, 최대 100MB)' },
      { method: 'GET', path: '/api/files/list', name: '파일 목록', description: '업로드된 파일 목록 (폴더별 필터)' },
      { method: 'GET', path: '/api/files/view/:filename', name: '파일 조회', description: '파일 다운로드/표시' },
      { method: 'DELETE', path: '/api/files/:id', name: '파일 삭제', description: '파일 삭제 (소유자/Admin만)' },
      { method: 'GET', path: '/health', name: '헬스체크', description: '서비스 상태 확인' },
    ]
  },

  devteam: {
    name: 'DevTeam',
    category: '개발팀',
    baseUrl: '/api',
    endpoints: [
      { method: 'GET', path: '/api/projects', name: '프로젝트 목록', description: '개발 프로젝트 목록' },
      { method: 'POST', path: '/api/projects', name: '프로젝트 생성', description: '새 프로젝트 생성' },
      { method: 'GET', path: '/api/projects/:id/tasks', name: '태스크 목록', description: '프로젝트별 태스크' },
      { method: 'POST', path: '/api/projects/:id/tasks', name: '태스크 생성', description: '새 태스크 생성' },
      { method: 'GET', path: '/api/agents', name: '에이전트 목록', description: 'AI 에이전트 조회' },
      { method: 'POST', path: '/api/projects/:id/chat', name: '기획 채팅', description: 'PD 에이전트와 대화' },
      { method: 'GET', path: '/api/meeting-notes', name: '회의록 목록', description: '회의록 조회' },
      { method: 'GET', path: '/api/managing/stats', name: '관리 통계', description: '프로젝트 통계' },
    ]
  },

  work: {
    name: 'Work',
    category: '협업',
    baseUrl: '/api/v1',
    endpoints: [
      { method: 'GET', path: '/api/v1/projects', name: '프로젝트 목록', description: '협업 프로젝트 조회' },
      { method: 'POST', path: '/api/v1/projects', name: '프로젝트 생성', description: '새 프로젝트 생성' },
      { method: 'GET', path: '/api/v1/projects/:id/wiki', name: '위키 페이지', description: '프로젝트 위키 조회' },
      { method: 'POST', path: '/api/v1/projects/:id/wiki', name: '위키 작성', description: '위키 페이지 생성' },
      { method: 'GET', path: '/api/v1/tasks', name: '태스크 목록', description: '태스크 조회' },
      { method: 'GET', path: '/api/v1/projects/:id/assets', name: '에셋 목록', description: '프로젝트 에셋 조회' },
      { method: 'POST', path: '/api/v1/projects/:id/assets/upload', name: '에셋 업로드', description: '파일 업로드' },
      { method: 'GET', path: '/api/v1/dashboard', name: '대시보드', description: '사용자 대시보드' },
    ]
  },

  openclaude: {
    name: 'Claude Terminal',
    category: '터미널',
    baseUrl: '/api',
    endpoints: [
      { method: 'GET', path: '/api/projects', name: '프로젝트 목록', description: 'ilouli 프로젝트 조회' },
      { method: 'GET', path: '/api/sessions', name: '세션 목록', description: 'Claude CLI 세션 조회' },
      { method: 'POST', path: '/api/sessions', name: '세션 생성', description: '새 Claude 세션 시작' },
      { method: 'DELETE', path: '/api/sessions/:id', name: '세션 삭제', description: '세션 종료 및 삭제' },
      { method: 'WS', path: '/socket.io', name: '실시간 연결', description: 'WebSocket 실시간 터미널' },
    ]
  },

  stockanalysis: {
    name: 'Stock Analysis',
    category: '분석',
    baseUrl: '/api',
    endpoints: [
      { method: 'GET', path: '/api/analysis', name: '분석 목록', description: '종목 분석 결과 조회' },
      { method: 'POST', path: '/api/analysis/run', name: '분석 실행', description: '뉴스 기반 종목 분석 시작' },
      { method: 'GET', path: '/api/analysis/:id', name: '분석 상세', description: '분석 결과 상세 조회' },
      { method: 'GET', path: '/api/stocks/profiles', name: '종목 프로필', description: '관심 종목 프로필' },
      { method: 'GET', path: '/api/dashboard', name: '대시보드', description: '분석 대시보드' },
      { method: 'GET', path: '/api/scheduler/status', name: '스케줄러 상태', description: '자동 분석 스케줄 상태' },
    ]
  },

  news: {
    name: 'News Insight',
    category: '뉴스',
    baseUrl: '/api',
    endpoints: [
      { method: 'GET', path: '/api/health', name: '헬스체크', description: '서비스 상태 확인' },
      { method: 'GET', path: '/api/insight/latest', name: '최신 인사이트', description: '최신 뉴스 인사이트 조회' },
      { method: 'GET', path: '/api/pipeline/status', name: '파이프라인 상태', description: '뉴스 파이프라인 실행 상태' },
      { method: 'GET', path: '/api/pipeline/stats', name: '파이프라인 통계', description: '파이프라인 통계 정보' },
    ]
  },

  markdown: {
    name: 'Markdown Blog',
    category: '에디터',
    baseUrl: '/api',
    endpoints: [
      { method: 'GET', path: '/api/health', name: '헬스체크', description: '서비스 상태 확인' },
      { method: 'GET', path: '/api/documents', name: '문서 목록', description: '문서 목록 조회 (페이지네이션, 태그 필터)' },
      { method: 'GET', path: '/api/documents/:id', name: '문서 상세', description: '문서 상세 조회' },
      { method: 'POST', path: '/api/documents', name: '문서 생성', description: '새 문서 생성' },
      { method: 'PUT', path: '/api/documents/:id', name: '문서 수정', description: '문서 수정' },
      { method: 'DELETE', path: '/api/documents/:id', name: '문서 삭제', description: '문서 삭제' },
      { method: 'GET', path: '/api/documents/tree', name: '문서 트리', description: '전체 문서 트리 (중첩 JSON)' },
      { method: 'POST', path: '/api/youtube/submit', name: 'YouTube 제출', description: 'YouTube URL 요약 큐 등록' },
      { method: 'GET', path: '/api/youtube/jobs', name: 'YouTube 작업 목록', description: 'YouTube 요약 작업 목록' },
      { method: 'POST', path: '/api/share', name: '공유 링크 생성', description: '시한부 공유 링크 생성' },
      { method: 'GET', path: '/api/share/:shareId', name: '공유 문서 조회', description: '공유 링크로 문서 조회 (공개)' },
    ]
  },

  nexus: {
    name: 'Nexus',
    category: '지식 그래프',
    baseUrl: '/api',
    endpoints: [
      { method: 'GET', path: '/api/health', name: '헬스체크', description: '서비스 상태 확인' },
    ]
  },

  invest: {
    name: 'Invest',
    category: '투자',
    baseUrl: '/api/invest',
    endpoints: [
      { method: 'GET', path: '/api/invest/health', name: '헬스체크', description: '서비스 상태 확인' },
      { method: 'GET', path: '/api/invest/market', name: '시장 데이터', description: '국내+해외 시장 데이터 조회' },
      { method: 'GET', path: '/api/invest/economy', name: '경제 지표', description: '주요 경제 지표 조회' },
      { method: 'GET', path: '/api/invest/compare', name: '투자처 비교', description: '투자처 비교 분석' },
      { method: 'GET', path: '/api/invest/screener', name: '종목 스크리너', description: '조건별 종목 스크리닝' },
    ]
  }
};

/**
 * 프로젝트 이름으로 API 레지스트리 조회
 */
export const getProjectApis = (projectName) => {
  return PROJECT_API_REGISTRY[projectName] || null;
};

/**
 * 프로젝트의 카테고리 조회
 */
export const getProjectCategory = (projectName) => {
  const registry = PROJECT_API_REGISTRY[projectName];
  return registry?.category || null;
};

/**
 * 모든 프로젝트 이름 목록
 */
export const getAllProjectNames = () => {
  return Object.keys(PROJECT_API_REGISTRY);
};

export default PROJECT_API_REGISTRY;
